// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Qtds","description":"PatientConsentPreview_description__5HhIn"};